(function () {
  "use strict";

  if (window.ProcoloredProductInformation?.initAll) {
    window.ProcoloredProductInformation.initAll(document);
    return;
  }

  const instances = new Map();
  const countdownParts = new WeakMap();

  function parseJson(node, fallback) {
    try {
      return node ? JSON.parse(node.textContent || "") : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function formatUtcTime(value) {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return "";

    const pad = (part) => String(part).padStart(2, "0");
    return [
      date.getFullYear(),
      "/",
      date.getMonth() + 1,
      "/",
      pad(date.getDate()),
      " ",
      pad(date.getHours()),
      ":",
      pad(date.getMinutes()),
      ":",
      pad(date.getSeconds()),
    ].join("");
  }

  function formatMoney(cents) {
    const settings = window.theme?.settings || {};
    let format = settings.currency_code_enabled
      ? settings.money_with_currency_format
      : settings.money_format;
    const moneySpanMatch = format?.match(
      /<span\s+class=["']money["']>(.*?)<\/span>/i
    );
    if (moneySpanMatch) format = moneySpanMatch[1];

    if (typeof window.formatMoney === "function") {
      return window.formatMoney(cents, format);
    }

    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function setMoney(node, value) {
    if (!node) return;
    const money = node.querySelector(".money");
    (money || node).textContent = value;
  }

  function getVariantId(root, fallbackId) {
    const variantInput = root.querySelector('form [name="id"]');
    if (variantInput?.value) return variantInput.value;

    const checkedInput = root.querySelector(
      'variant-selects input[type="radio"]:checked, [id^="variant-selects-"] input[type="radio"]:checked'
    );
    if (checkedInput?.dataset.variantId) return checkedInput.dataset.variantId;

    const selectedOption = root.querySelector('[id^="variant-selects-"] select option:checked');
    if (selectedOption?.dataset.variantId) return selectedOption.dataset.variantId;

    const urlVariant = new URL(window.location.href).searchParams.get("variant");
    return urlVariant || fallbackId;
  }

  function getDiscountState(variant, effectType) {
    const price = Number(variant?.price || 0);
    const compareAtPrice = Number(variant?.compare_at_price || 0);
    const rawDiscount = variant?.custom_discount;

    if (!effectType || rawDiscount === "" || rawDiscount == null) {
      return {
        active: false,
        price,
        compareAtPrice,
        discount: 0,
        nextBoundary: null,
      };
    }

    const now = Date.now();
    const start = Date.parse(variant.start_date || "");
    const end = Date.parse(variant.end_date || "");
    const discountText = String(rawDiscount);
    const discount = discountText.includes("%")
      ? Math.round((price * (parseFloat(discountText) || 0)) / 100)
      : Number(rawDiscount || 0);
    const active =
      (!Number.isFinite(start) || now >= start) &&
      (!Number.isFinite(end) || now < end) &&
      discount > 0;

    return {
      active,
      price: active ? Math.max(0, price - discount) : price,
      compareAtPrice: active ? price : compareAtPrice,
      discount: active ? discount : 0,
      nextBoundary:
        Number.isFinite(start) && now < start
          ? start
          : Number.isFinite(end) && now < end
            ? end
            : null,
    };
  }

  function createVariantPricing(variant, effectType) {
    if (!variant) return null;
    const state = getDiscountState(variant, effectType);
    return {
      variantId: variant.id,
      basePrice: Number(variant.price || 0),
      effectivePrice: Number(state.price || 0),
      compareAtPrice: Number(state.compareAtPrice || 0),
      discountActive: Boolean(state.active),
      discountAmount: Number(state.discount || 0),
      available: Boolean(variant.available),
      nextBoundary: state.nextBoundary,
    };
  }

  function getVariantPricing(sectionId, variantId) {
    const instance = Array.from(instances.values()).find(
      (item) => String(item.config.sectionId || "") === String(sectionId || "")
    );
    if (!instance) return null;

    const variant = instance.variants.find(
      (item) => String(item.id) === String(variantId || "")
    );
    return createVariantPricing(variant, instance.discountConfig.effectType);
  }

  function dispatchVariantPricing(instance, variant, state) {
    document.dispatchEvent(
      new CustomEvent("product:variant-pricing-change", {
        detail: {
          sectionId: instance.config.sectionId,
          variantId: variant.id,
          pricing: {
            variantId: variant.id,
            basePrice: Number(variant.price || 0),
            effectivePrice: Number(state.price || 0),
            compareAtPrice: Number(state.compareAtPrice || 0),
            discountActive: Boolean(state.active),
            discountAmount: Number(state.discount || 0),
            available: Boolean(variant.available),
            nextBoundary: state.nextBoundary,
          },
        },
      })
    );
  }

  function getStickyRoot(sectionId) {
    return Array.from(document.querySelectorAll("product-add-to-cart-sticky")).find(
      (node) => String(node.dataset.section || "") === String(sectionId || "")
    );
  }

  function updateCustomVariant(instance, state) {
    const activeCustomVariant = instance.root.querySelector(".js-custom-variant.active");
    if (!activeCustomVariant) return;

    const customPrice = activeCustomVariant.querySelector(".custom-product-price");
    const customCompare = activeCustomVariant.querySelector(
      ".custom-product-price-compare"
    );
    const finalPrice = formatMoney(state.price);
    const comparePrice = formatMoney(state.compareAtPrice);

    setMoney(customPrice, finalPrice);
    if (customCompare) {
      setMoney(customCompare, comparePrice);
      customCompare.style.display =
        state.compareAtPrice > 0 && state.price !== state.compareAtPrice
          ? "block"
          : "none";
    }
  }

  function updatePrices(instance, state) {
    const { root, reminder, config } = instance;
    const finalPrice = formatMoney(state.price);
    const originPrice = formatMoney(state.compareAtPrice);
    const discountPrice = formatMoney(state.discount);

    setMoney(reminder?.querySelector("[data-final-price]"), finalPrice);
    setMoney(reminder?.querySelector("[data-origin-price]"), originPrice);
    setMoney(
      reminder?.querySelector("[data-final-sale-price]"),
      `-${discountPrice}`
    );

    root.querySelectorAll(".activity-price-display ins .money").forEach((node) => {
      node.textContent = finalPrice;
    });
    root
      .querySelectorAll(
        ".activity-price-display .del .money, .activity-price-display del .money"
      )
      .forEach((node) => {
        node.textContent = originPrice;
      });
    root.querySelectorAll("[data-pp-amount]").forEach((node) => {
      node.dataset.ppAmount = (state.price / 100).toFixed(2);
    });

    const sticky = getStickyRoot(config.sectionId);
    setMoney(sticky?.querySelector(".activity-price-display ins .money"), finalPrice);
    setMoney(
      sticky?.querySelector(
        ".activity-price-display .del .money, .activity-price-display del .money"
      ),
      originPrice
    );
    sticky?.querySelectorAll("[data-pp-amount]").forEach((node) => {
      node.dataset.ppAmount = (state.price / 100).toFixed(2);
    });

    updateCustomVariant(instance, state);
  }

  function setReminderState(instance, visible, hideFinalPrice) {
    const { reminder } = instance;
    if (!reminder) return;

    reminder.style.display = visible ? "inline-flex" : "none";
    reminder.style.opacity = visible ? "1" : "0";

    const finalPrice = reminder.querySelector("[data-final-price]");
    if (finalPrice) finalPrice.style.display = hideFinalPrice ? "none" : "";
  }

  function renderDiscount(instance) {
    const { root, config, variants, discountConfig } = instance;
    const variantId = getVariantId(root, config.selectedVariantId);
    const variant =
      variants.find((item) => String(item.id) === String(variantId)) || variants[0];
    if (!variant) return;

    const state = getDiscountState(variant, discountConfig.effectType);
    window.clearTimeout(instance.boundaryTimer);
    instance.boundaryTimer = null;

    if (state.active) {
      root.classList.add("showActivityPrice");
      root.querySelectorAll(".activity-price-display").forEach((node) => {
        node.style.display = "block";
        node.classList.add("show");
      });
      root.querySelectorAll(".daily-price-display").forEach((node) => {
        node.style.display = "none";
      });
      updatePrices(instance, state);
      setReminderState(instance, true, true);
    } else {
      root.classList.remove("showActivityPrice");
      root.querySelectorAll(".activity-price-display").forEach((node) => {
        node.style.display = "none";
        node.classList.remove("show");
      });
      root.querySelectorAll(".daily-price-display").forEach((node) => {
        node.style.display = "block";
      });

      updateCustomVariant(instance, {
        price: Number(variant.price || 0),
        compareAtPrice: Number(variant.compare_at_price || 0),
      });
      const showStandaloneReminder =
        !discountConfig.effectType && Boolean(config.variantsDisplayCustomDiscounts);
      setReminderState(instance, showStandaloneReminder, false);
    }

    if (state.nextBoundary) {
      instance.boundaryTimer = window.setTimeout(
        () => renderDiscount(instance),
        Math.min(state.nextBoundary - Date.now() + 50, 2147483647)
      );
    }

    dispatchVariantPricing(instance, variant, state);
  }

  function getCountdownTarget(node, now) {
    const start = Date.parse(node.dataset.countdownStart || node.dataset.countdown || "");
    const end = Date.parse(node.dataset.countdownEnd || "");

    if (Number.isFinite(start) && now < start) return start;
    if (Number.isFinite(end) && now < end) return end;
    return null;
  }

  function setCountdownContainerVisible(node, visible) {
    const container = node.closest(".product-flash-sale-countdown");
    if (container) container.style.display = visible ? "" : "none";
  }

  function renderCountdownNode(node, remainingMilliseconds) {
    const totalSeconds = Math.max(0, Math.floor(remainingMilliseconds / 1000));
    if (node.dataset.productCountdownSecond === String(totalSeconds)) return;

    const values = [
      Math.floor(totalSeconds / 86400),
      Math.floor((totalSeconds % 86400) / 3600),
      Math.floor((totalSeconds % 3600) / 60),
      totalSeconds % 60,
    ];
    const style = String(node.dataset.countdownStyle || "2");
    let parts = countdownParts.get(node);

    if (!parts || parts.some((part) => !part.isConnected || !node.contains(part))) {
      const fragment = document.createDocumentFragment();
      if (style === "1") {
        parts = values.map((value, index) => {
          const valueNode = document.createElement("span");
          fragment.appendChild(valueNode);
          if (index < values.length - 1) fragment.appendChild(document.createTextNode(":"));
          return valueNode;
        });
      } else {
        const labels = ["days", "hours", "mins", "secs"];
        parts = values.map((value, index) => {
          const block = document.createElement("div");
          const valueNode = document.createElement("div");
          const labelNode = document.createElement("div");
          block.className = "time-block";
          valueNode.className = "time-value";
          labelNode.className = "time-label";
          labelNode.textContent = labels[index];
          block.append(valueNode, labelNode);
          fragment.appendChild(block);
          return valueNode;
        });
      }

      node.replaceChildren(fragment);
      countdownParts.set(node, parts);
    }

    parts.forEach((part, index) => {
      const nextValue = String(values[index]).padStart(2, "0");
      if (part.textContent !== nextValue) part.textContent = nextValue;
    });
    node.dataset.productCountdownSecond = String(totalSeconds);
  }

  function updateCountdowns(instance) {
    const now = Date.now();
    let hasActiveCountdown = false;
    const activeTargets = [];

    instance.countdownNodes.forEach((node) => {
      if (!node.isConnected || node.closest("[hidden]")) return;
      const target = getCountdownTarget(node, now);

      if (!target) {
        renderCountdownNode(node, 0);
        node.dataset.countdownState = "expired";
        setCountdownContainerVisible(node, false);
        return;
      }

      hasActiveCountdown = true;
      activeTargets.push(String(target));
      node.dataset.countdownState = "active";
      setCountdownContainerVisible(node, true);
      renderCountdownNode(node, target - now);
    });

    const phaseKey = activeTargets.join("|");
    if (instance.countdownPhaseKey !== null && instance.countdownPhaseKey !== phaseKey) {
      renderDiscount(instance);
    }
    instance.countdownPhaseKey = phaseKey;

    window.clearTimeout(instance.countdownTimer);
    instance.countdownTimer = null;
    if (!hasActiveCountdown || document.hidden) return;

    const delay = Math.max(100, 1000 - (Date.now() % 1000) + 20);
    instance.countdownTimer = window.setTimeout(() => updateCountdowns(instance), delay);
  }

  function scheduleRefresh(instance) {
    window.clearTimeout(instance.refreshTimer);
    instance.refreshTimer = window.setTimeout(() => {
      renderDiscount(instance);
      updateCountdowns(instance);
    }, 0);
  }

  function destroy(root) {
    const productRoot = root?.matches?.('[id^="ProductInfo-"]')
      ? root
      : root?.querySelector?.('[id^="ProductInfo-"]');
    const instance = instances.get(productRoot);
    if (!instance) return;

    window.clearTimeout(instance.boundaryTimer);
    window.clearTimeout(instance.countdownTimer);
    window.clearTimeout(instance.refreshTimer);
    instance.customVariantObserver?.disconnect();
    instance.root.removeEventListener(
      "change",
      instance.handleVariantChange,
      true
    );
    document.removeEventListener(
      "product:variant-change",
      instance.handleProductVariantChange
    );
    document.removeEventListener("visibilitychange", instance.handleVisibilityChange);
    instances.delete(productRoot);
  }

  function init(root, config) {
    const productRoot = root?.matches?.('[id^="ProductInfo-"]')
      ? root
      : root?.querySelector?.('[id^="ProductInfo-"]');
    if (!productRoot) return null;
    if (instances.has(productRoot)) return instances.get(productRoot);

    const reminder = productRoot.querySelector(
      "custom-automatic-discount-reminder"
    );
    const variants = parseJson(
      reminder?.querySelector('script[type="application/json"]'),
      []
    );
    const discountConfig = parseJson(
      productRoot.querySelector("[data-product-discount-config]"),
      {}
    );
    const instance = {
      root: productRoot,
      config,
      variants,
      discountConfig,
      reminder,
      boundaryTimer: null,
      countdownTimer: null,
      refreshTimer: null,
      countdownPhaseKey: null,
      countdownNodes: Array.from(
        productRoot.querySelectorAll("[data-countdown], [data-countdown-end]")
      ),
      customVariantObserver: null,
      activeCustomVariant: null,
      handleVariantChange: null,
      handleProductVariantChange: null,
      handleVisibilityChange: null,
    };

    instance.handleVariantChange = (event) => {
      if (!event.target.closest('variant-selects, [id^="variant-selects-"], custom-variants, form')) {
        return;
      }
      scheduleRefresh(instance);
    };
    instance.handleProductVariantChange = (event) => {
      if (String(event.detail?.sectionId || "") !== String(config.sectionId || "")) return;
      scheduleRefresh(instance);
    };
    instance.handleVisibilityChange = () => {
      if (document.hidden) {
        window.clearTimeout(instance.countdownTimer);
        instance.countdownTimer = null;
        return;
      }
      renderDiscount(instance);
      updateCountdowns(instance);
    };

    productRoot.addEventListener("change", instance.handleVariantChange, true);
    document.addEventListener(
      "product:variant-change",
      instance.handleProductVariantChange
    );
    document.addEventListener("visibilitychange", instance.handleVisibilityChange);

    const customVariants = productRoot.querySelector("custom-variants");
    if (customVariants) {
      instance.activeCustomVariant = customVariants.querySelector(".js-custom-variant.active");
      instance.customVariantObserver = new MutationObserver(() => {
        const active = customVariants.querySelector(".js-custom-variant.active");
        if (active === instance.activeCustomVariant) return;
        instance.activeCustomVariant = active;
        scheduleRefresh(instance);
      });
      instance.customVariantObserver.observe(customVariants, {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
        subtree: true,
      });
    }

    instances.set(productRoot, instance);
    renderDiscount(instance);
    updateCountdowns(instance);
    return instance;
  }

  function initConfigNode(configNode) {
    const config = parseJson(configNode, {});
    const sectionRoot = configNode.closest(".shopify-section");
    const root =
      document.getElementById(`ProductInfo-${config.sectionId}`) ||
      sectionRoot?.querySelector?.('[id^="ProductInfo-"]');
    return init(root, config);
  }

  function initAll(scope) {
    const target = scope?.querySelectorAll ? scope : document;
    instances.forEach((instance, productRoot) => {
      if (!productRoot.isConnected) destroy(productRoot);
    });
    if (target.matches?.("[data-product-information-enhancement-config]")) {
      initConfigNode(target);
    }
    target
      .querySelectorAll?.("[data-product-information-enhancement-config]")
      .forEach(initConfigNode);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
  document.addEventListener("shopify:section:select", (event) => {
    initAll(event.target);
  });
  document.addEventListener("shopify:block:select", (event) => {
    initAll(event.target?.closest?.(".shopify-section") || event.target);
  });
  document.addEventListener("shopify:section:unload", (event) => {
    const productRoot = event.target?.querySelector?.('[id^="ProductInfo-"]');
    if (productRoot) destroy(productRoot);
  });

  window.ProcoloredProductInformation = {
    destroy,
    destroySection: destroy,
    formatUtcTime,
    getVariantPricing,
    init,
    initAll,
    initSection: initAll,
  };

  initAll(document);
})();
